import React from 'react';
import { Loader, BaasicTable, BaasicHeader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import '@progress/kendo-theme-default/dist/all.css';
import _ from 'lodash';

const WarehouseListTemplate = ({ t, viewStore, viewStore: { listStore, tableData, queryUtility } }) => {
	if (viewStore.loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.WAREHOUSES"></BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
				}}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
		</section>
	);
};

export default defaultTemplate(WarehouseListTemplate);
